module.exports = __webpack_public_path__ + "img/webworthy-5.c8de151f.jpg";